var classof = require('../internals/classof');
var uncurryThis = require('../internals/function-uncurry-this');

var slice = uncurryThis(''.slice);

module.exports = function (it) {
  return slice(classof(it), 0, 3) === 'Big';
};



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/web/app/themes/mea/node_modules/core-js/internals/is-big-int-array.js
// module id = 246
// module chunks = 0